import { useMemo } from 'react';
import DOMPurify from 'dompurify';

export const FormatMessage = ({
  as: Component = 'span',
  message,
  values
}: {
  as?: keyof JSX.IntrinsicElements;
  message: string;
  values?: Record<string, string>;
}) => {
  const clean = useMemo(() => {
    if (values) {
      for (const [key, value] of Object.entries(values)) {
        message = message.replace(`{${key}}`, value);
      }
    }
    return DOMPurify.sanitize(message);
  }, [message, values]);
  return clean ? (
    <Component dangerouslySetInnerHTML={{ __html: clean }} />
  ) : null;
};

export const SplitFormattedMessage = (props: {
  message: string;
  split: string;
  children: JSX.Element | JSX.Element[];
}) => {
  const { message, split, children } = props;
  const messageSplit: string[] = message?.split(`{${split}}`) || [];

  return (
    <>
      {messageSplit[0] ? <FormatMessage message={messageSplit[0]} /> : null}
      {children}
      {messageSplit[1] ? <FormatMessage message={messageSplit[1]} /> : null}
    </>
  );
};
